import "./frontend.scss";
import "swiper/swiper-bundle.css";
import "aos/dist/aos.css";

// import './vue/vue-router'
import "./vue/filter";
import Router from "./util/Router";
// import masterDataPageGarage from './routes/home'
/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */

import common from "./routes/common";
import home from "./routes/home";
import contact from "./routes/contact";
import postTypeArchiveDataWarehouse from "./routes/store";
import postTypeArchiveStory from "./routes/story";
import startTemplateArchiveEvent from "./routes/event";
import startTemplateTemplateHre from "./routes/start";

const routes = new Router({
  common,
  home,
  contact,
  postTypeArchiveDataWarehouse,
  postTypeArchiveStory,
  startTemplateArchiveEvent,
  startTemplateTemplateHre,
});

window.addEventListener("DOMContentLoaded", () => {
  routes.loadEvents();
});
